export const Experiences = [
  {
    id: "exp-1",
    title: {
      pt: "Desenvolvedora Mobile - Defesa Civil do Estado de Amazonas (2023 - no momento)",
      en: "Mobile Developer - Amazonas State Civil Defense (2023 - Present)",
    },
    description: {
      pt: "Atuo no desenvolvimento de aplicativos móveis em React Native, tanto para uso interno quanto externo da Defesa Civil do Amazonas. Atualmente, faço parte de uma equipe de duas pessoas, adotando a metodologia ágil SCRUM. Minhas responsabilidades incluem a criação, manutenção e evolução contínua dos aplicativos móveis, garantindo alta performance, escalabilidade e uma experiência de usuário eficiente, mesmo em ambientes com conectividade limitada.",
      en: "I work on the development of mobile applications using React Native, both for internal and external use by the Amazonas Civil Defense. Currently, I am part of a two-person team, adopting the SCRUM agile methodology. My responsibilities include creating, maintaining, and continuously improving the mobile applications, ensuring high performance, scalability, and an efficient user experience, even in environments with limited connectivity.",
    },
  },
];
